import { Outlet } from 'react-router-dom';
import { ErrorBoundary } from './ErrorBoundary';

export const ErrorBoundaryLayout = () => (
  <ErrorBoundary>
    <Outlet />
  </ErrorBoundary>
);
